import { axios, def, handleError } from './internal';

function post(path, setData, emptyData) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post(path)
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, data: res.data.data, error: null });
            } else {
                setData((prev) => ({ ...prev, loading: false, error: res.data.message ?? 'Failed' }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false, error: err.message ?? 'Request failed' }));
            handleError(err);
        });
}

function AdminCfWorkers(setData) {
    post('/api/admin_cf_workers', setData);
}

function AdminCfR2(setData) {
    post('/api/admin_cf_r2', setData);
}

function AdminAdsense(setData) {
    post('/api/admin_adsense', setData);
}

export { AdminCfWorkers, AdminCfR2, AdminAdsense };
